import React from 'react';
import Select, {
  components,
  DropdownIndicatorProps,
  IndicatorSeparatorProps,
  OnChangeValue,
  ActionMeta,
} from 'react-select';
import { SelectorIcon } from '@heroicons/react/solid';
import { OptionType as Option, InputSlectProps } from './Types';
import InputLabel from './InputLabel';
import { useTranslation } from 'react-i18next';
import { useCommonSelector } from '@wajeez-web/stores/common';

const DropdownIndicator = (props: DropdownIndicatorProps<Option, true>) => {
  return (
    <components.DropdownIndicator {...props}>
      <SelectorIcon className="h-5 w-5 text-gray-400" />
    </components.DropdownIndicator>
  );
};

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  backgroundColor: 'white',
  marginBottom: 8,
  marginTop: 8,
  width: 1,
};

const IndicatorSeparator = ({
  innerProps,
}: IndicatorSeparatorProps<Option, true>) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};
//  TODO: change the selector
const InputSelect = ({
  placeholder = 'Select...',
  name,
  value,
  isMulti = undefined,
  options,
  onChange,
  label,
  required = false,
  isMenuOpen,
  onSearch,
  inputValue,
  controlStyle,
  optionStyle,
  isClearable = false,
}: InputSlectProps) => {
  const handleChange = (value: OnChangeValue<Option, true>) => {
    onChange(name, value);
  };

  const { dir } = useCommonSelector((state) => state.common.settings);

  const { t } = useTranslation();

  return (
    <div>
      {label && <InputLabel text={label} name={name} required={required} />}
      <Select
        inputValue={inputValue}
        isSearchable={onSearch ? true : false}
        className="input"
        options={[...options]}
        onInputChange={(val) => onSearch && onSearch(val)}
        menuIsOpen={isMenuOpen}
        isMulti={isMulti || undefined}
        placeholder={t(
          `inputs.placeholders.${placeholder}`,
          placeholder
        ).toString()}
        name={name}
        defaultMenuIsOpen={isMenuOpen}
        onChange={handleChange}
        value={value || undefined}
        styles={{
          control: (base, state) => {
            if (controlStyle) {
              return {
                ...base,
                minHeight: '36px !important',
                // height: "36px !important",
                padding: '0px !important',
                textAlign: dir === 'ltr' ? 'left' : 'right',
                ' --tw-ring-opacity': 1,
                '--tw-ring-opacity': state.isFocused ? 0.1 : 'default',
                ' --tw-ring-color': state.isFocused
                  ? 'var(--theme-ring-color)'
                  : 'default',
                '--tw-ring-offset-shadow': state.isFocused
                  ? 'var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)'
                  : 'default',
                '--tw-ring-shadow': state.isFocused
                  ? 'var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)'
                  : 'default',
                boxShadow: state.isFocused
                  ? ' var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)'
                  : 'default',
                ...controlStyle(state),
              };
            } else {
              return {
                ...base,
                minHeight: '36px !important',
                // height: "36px !important",
                padding: '0px !important',
                textAlign: dir === 'ltr' ? 'left' : 'right',
                ' --tw-ring-opacity': 1,
                '--tw-ring-opacity': state.isFocused ? 0.1 : 'default',
                ' --tw-ring-color': state.isFocused
                  ? 'var(--theme-ring-color)'
                  : 'default',
                '--tw-ring-offset-shadow': state.isFocused
                  ? 'var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)'
                  : 'default',
                '--tw-ring-shadow': state.isFocused
                  ? 'var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)'
                  : 'default',
                boxShadow: state.isFocused
                  ? ' var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)'
                  : 'default',
              };
            }
          },
          menu: (provided) => ({
            ...provided,
            position: 'absolute',
            'z-index': '999 !important',
            textAlign: dir === 'ltr' ? 'left' : 'right',
          }),
          container: (base) => ({
            ...base,
            fontSize: '14px !important',
            padding: '0px !important',
            height: 'auto !important',
          }),
          option: (base, state) => {
            if (optionStyle) {
              return {
                ...base,
                ...optionStyle(state),
              };
            } else {
              return base;
            }
          },
        }}
        theme={(theme) => ({
          ...theme,
          zIndex: 999,
          border: '0px none',
          width: '100%',
          borderRadius: 6,
          padding: 0,
          margin: 0,
          colors: {
            ...theme.colors,

            primary: 'var(--theme-primary)',
          },
        })}
        components={{ DropdownIndicator, IndicatorSeparator }}
        noOptionsMessage={() => (
          <div>
            {t(`selects.labels.${'No options'}`, 'No options').toString()}
          </div>
        )}
        isClearable={isClearable}
      />
    </div>
  );
};

export default InputSelect;
